// HubLogo.jsx -- Animated Hub logo, 3 states: idle | thinking | active
// ASCII only. var declarations. ESM only. Inline styles only.

import React from 'react';

var _logoStyleId = 'hub-logo-keyframes';

function ensureStyles() {
  if (typeof document === 'undefined') return;
  if (document.getElementById(_logoStyleId)) return;
  var s = document.createElement('style');
  s.id = _logoStyleId;
  s.textContent = [
    '@keyframes hl-breathe { 0%,100% { r: 10; opacity: 1; } 50% { r: 11.5; opacity: 0.85; } }',
    '@keyframes hl-float { 0%,100% { transform: translate(0,0); } 50% { transform: translate(0,-1.5px); } }',
    '@keyframes hl-line-fade { 0%,100% { opacity: 0.25; } 50% { opacity: 0.12; } }',
    '@keyframes hl-think-core { 0%,100% { r: 10; } 25% { r: 12; } 50% { r: 9; } 75% { r: 11; } }',
    '@keyframes hl-orbit { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }',
    '@keyframes hl-dash { 0% { stroke-dashoffset: 0; } 100% { stroke-dashoffset: -176; } }',
    '@keyframes hl-active-core { 0%,100% { r: 10; } 30% { r: 13; } 60% { r: 9; } }',
    '@keyframes hl-pulse-out { 0% { r: 12; opacity: 0.4; } 100% { r: 35; opacity: 0; } }',
    '@keyframes hl-active-line { 0%,100% { opacity: 0.5; stroke-width: 1.2px; } 50% { opacity: 0.9; stroke-width: 2px; } }',
    '@keyframes hl-active-sat { 0%,100% { opacity: 0.7; } 50% { opacity: 1; } }'
  ].join('\n');
  document.head.appendChild(s);
}

var SAT_POS = [
  { cx: 18, cy: 18 },
  { cx: 62, cy: 18 },
  { cx: 18, cy: 62 },
  { cx: 62, cy: 62 }
];

var LINE_POS = [
  { x1: 22, y1: 22, x2: 33, y2: 33 },
  { x1: 58, y1: 22, x2: 47, y2: 33 },
  { x1: 22, y1: 58, x2: 33, y2: 47 },
  { x1: 58, y1: 58, x2: 47, y2: 47 }
];

export default function HubLogo(props) {
  ensureStyles();
  var state = props.state || 'idle';
  var size = props.size || 28;
  var accent = props.color || '#4F6EF7';

  if (state === 'thinking') {
    return (
      <svg width={size} height={size} viewBox="0 0 80 80" style={props.style || {}}>
        <circle cx="40" cy="40" r="10" fill={accent}
          style={{ animation: 'hl-think-core 1.2s ease-in-out infinite' }} />
        {SAT_POS.map(function(sp, i) {
          var angle = i * 90;
          var ox = 40 + 25 * Math.cos(angle * Math.PI / 180);
          var oy = 40 + 25 * Math.sin(angle * Math.PI / 180);
          return (
            <g key={i} style={{
              transformOrigin: '40px 40px',
              animation: 'hl-orbit 3s linear infinite',
              animationDelay: (-i * 0.75) + 's'
            }}>
              <circle cx={ox} cy={oy} r="4.5" fill={accent} opacity={0.6 - i * 0.1} />
            </g>
          );
        })}
      </svg>
    );
  }

  if (state === 'active') {
    return (
      <svg width={size} height={size} viewBox="0 0 80 80" style={props.style || {}}>
        {[0, 0.7, 1.4].map(function(delay, i) {
          return (
            <circle key={'p' + i} cx="40" cy="40" r="12" fill="none" stroke={accent} strokeWidth="1"
              style={{ animation: 'hl-pulse-out 2s ease-out infinite ' + delay + 's' }} />
          );
        })}
        {LINE_POS.map(function(l, i) {
          return (
            <line key={'l' + i} x1={l.x1} y1={l.y1} x2={l.x2} y2={l.y2} stroke={accent}
              style={{ animation: 'hl-active-line 0.6s ease-in-out infinite ' + (i * 0.15) + 's' }} />
          );
        })}
        {SAT_POS.map(function(sp, i) {
          return (
            <circle key={'s' + i} cx={sp.cx} cy={sp.cy} r="5.5" fill={accent}
              style={{ animation: 'hl-active-sat 0.8s ease-in-out infinite ' + (i * 0.15) + 's' }} />
          );
        })}
        <circle cx="40" cy="40" r="10" fill={accent}
          style={{ animation: 'hl-active-core 0.8s ease-in-out infinite' }} />
      </svg>
    );
  }

  // idle (default)
  return (
    <svg width={size} height={size} viewBox="0 0 80 80" style={props.style || {}}>
      <circle cx="40" cy="40" r="10" fill={accent}
        style={{ animation: 'hl-breathe 4s ease-in-out infinite' }} />
      {SAT_POS.map(function(sp, i) {
        return (
          <g key={'s' + i} style={{
            animation: 'hl-float 3s ease-in-out infinite',
            animationDelay: (i * 0.4) + 's'
          }}>
            <circle cx={sp.cx} cy={sp.cy} r="5.5" fill={accent} opacity={0.55} />
          </g>
        );
      })}
      {LINE_POS.map(function(l, i) {
        return (
          <line key={'l' + i} x1={l.x1} y1={l.y1} x2={l.x2} y2={l.y2}
            stroke={accent} strokeWidth="1.2"
            style={{
              animation: 'hl-line-fade 4s ease-in-out infinite',
              animationDelay: (i * 0.5) + 's'
            }} />
        );
      })}
    </svg>
  );
}
